import { useEffect, useRef, useState } from "react";
import { VALUE_HERO } from "@/data/content";

const prefersReduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

const useOnceInView = (ref, threshold) => {
  const [state, setState] = useState(() => (prefersReduced() ? "final" : "wait"));
  useEffect(() => {
    if (state !== "wait") return undefined;
    if (!("IntersectionObserver" in window)) { setState("final"); return undefined; }
    const io = new IntersectionObserver(([en]) => {
      if (en.isIntersecting) { setState("on"); io.disconnect(); }
    }, { threshold });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [ref, state, threshold]);
  return state;
};

const Arrow = () => (
  <span className="vh-arrow-wrap" data-testid="value-hero-arrow">
    <svg viewBox="0 0 100 60" className="vh-arrow" fill="none" stroke="#ff6600" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path className="vh-arrow-line" d="M6 30H90" pathLength="1" />
      <path className="vh-arrow-head" d="M70 11L92 30L70 49" />
    </svg>
  </span>
);

export const ValueHero = () => {
  const ref = useRef(null);
  const state = useOnceInView(ref, 0.4);
  return (
    <div className="cd-reveal mt-12">
    <div ref={ref} className={`cd-vh is-${state} border border-[#4a4a46] px-6 py-14 text-center sm:py-20`} data-testid="value-hero" data-state={state}>
      <p
        className="flex flex-col items-center justify-center gap-y-3 font-display text-[44px] font-semibold leading-[1.1] tracking-[-0.045em] text-[#f5f5ee] sm:flex-row sm:gap-x-[0.28em] sm:text-7xl lg:text-8xl"
        aria-label={`${VALUE_HERO.from} to ${VALUE_HERO.to}`}
        data-testid="value-hero-value"
      >
        <span className="vh-from relative" data-testid="value-hero-from">
          <span className="vh-from-text">{VALUE_HERO.from}</span>
          <span className="vh-strike" aria-hidden="true" />
        </span>
        <Arrow />
        <span className="vh-to text-[#ff6600]" data-testid="value-hero-to">
          {VALUE_HERO.to}
        </span>
      </p>
      <p className="vh-caption mt-5 text-base text-[#d8d8d0] sm:text-lg" data-testid="value-hero-caption">{VALUE_HERO.caption}</p>
    </div>
    </div>
  );
};
